import React, { useCallback, useEffect, useState } from 'react';
import { subscribe } from 'lib/EventBuser';
import SenderFormModal from '../../SenderFormModal';
import SendersTable from './SendersTable';
import { OPEN_CREATE_SENDER_MODAL } from './constants';
import { useObtainSenders } from './useObtainSenders';

function SendersSettings() {
    const { senders, loading, fetchSenders } = useObtainSenders();
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const handleOpenCreateModal = useCallback(() => {
        setIsCreateModalOpen(true);
    }, []);

    const handleCloseCreateModal = useCallback(() => {
        setIsCreateModalOpen(false);
    }, []);

    const handleCreateSuccess = useCallback(() => {
        fetchSenders();
        handleCloseCreateModal();
    }, [fetchSenders, handleCloseCreateModal]);

    useEffect(() => {
        const unsubscribe = subscribe(OPEN_CREATE_SENDER_MODAL, handleOpenCreateModal);
        return unsubscribe;
    }, [handleOpenCreateModal]);

    return (
        <div className="marketing-settings__senders">
            <SendersTable senders={senders} loading={loading} onRefresh={fetchSenders} />
            <SenderFormModal
                isOpen={isCreateModalOpen}
                onCancel={handleCloseCreateModal}
                onRequestClose={handleCloseCreateModal}
                onSuccess={handleCreateSuccess}
            />
        </div>
    );
}

SendersSettings.displayName = 'SendersSettings';

export default SendersSettings;
